import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Menu } from 'lucide-react';
import { Sidebar } from './Sidebar';
import { Logo } from '@/components/Logo';

export function AppShell() {
  const [drawerOpen, setDrawerOpen] = useState(false);

  // Travamento do scroll do body e ESC pra fechar — só quando drawer está aberto.
  useEffect(() => {
    if (!drawerOpen) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setDrawerOpen(false);
    };
    window.addEventListener('keydown', onKey);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [drawerOpen]);

  return (
    <div className="flex h-screen bg-surface-base text-text-primary">
      {/* Topbar mobile: aparece apenas abaixo de lg. */}
      <header className="lg:hidden fixed top-0 inset-x-0 z-40 h-14 bg-surface-sidebar text-text-inverse flex items-center justify-between px-4">
        <Logo variant="dark-bg" className="h-7 w-auto" />
        <button
          type="button"
          onClick={() => setDrawerOpen(true)}
          aria-label="Abrir menu"
          aria-expanded={drawerOpen}
          className="-mr-2 rounded-lg p-2 hover:bg-white/10"
        >
          <Menu size={22} />
        </button>
      </header>

      {/* Backdrop do drawer (só mobile, só quando aberto). */}
      {drawerOpen && (
        <div
          aria-hidden="true"
          onClick={() => setDrawerOpen(false)}
          className="lg:hidden fixed inset-0 z-40 bg-black/40"
        />
      )}

      <Sidebar open={drawerOpen} onNavigate={() => setDrawerOpen(false)} />

      <main className="flex-1 overflow-y-auto pt-14 lg:pt-0">
        <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:py-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
